import InfoCard from "@/components/InfoCard";
import {
  BriefcaseBusiness,
  Cake,
  CheckCircle,
  EllipsisVertical,
  Home,
  Mail,
  MapPin,
  Pencil,
  Phone,
  Plus,
  Trash,
  User,
} from "lucide-react";
import { useUserDetails } from "@/hooks/useUserDetails";
import { useUserDetailModal } from "@/contexts/UserDetailModalProvider";
import { useAddresses } from "@/contexts/AddressesProvider";
import { useTranslation } from "react-i18next";

export default function profileScreen() {
  const { data: userDetails, isLoading } = useUserDetails();
  const { open: openUserDetailsModal } = useUserDetailModal();

  const { addresses, openAddressModal, deleteAddress } = useAddresses();
  const { t } = useTranslation();

  return (
    <div className="p-4 h-full w-full flex justify-center">
      <div className="h-full w-full md:w-3/4 lg:w-1/2 py-4 md:py-8 lg:py-16 flex flex-col gap-12">
        <div className="flex items-center gap-4">
          <div className="h-10 w-10 rounded-full">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png"
              className="h-full w-full rounded-full"
            />
          </div>
          <h1 className="text-2xl font-bold">{userDetails?.name}</h1>
          <div
            className="hover:bg-yellow-50 rounded-lg p-2 flex items-center gap-2 justify-center cursor-pointer hover:ring-yellow-500 hover:ring transition-all duration-300 ms-auto"
            onClick={() => {
              openUserDetailsModal({
                showMissingFieldsOnly: false,
              });
            }}
          >
            <Pencil className="w-4 h-4 text-yellow-500" />
            <span className="text-sm text-yellow-500 font-semibold">
              {t("edit")}
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 flex-wrap gap-8">
          <InfoCard
            label={t("full_name")}
            value={userDetails?.name ?? "N/A"}
            isLoading={isLoading}
            icon={User}
            color="blue"
          />
          <InfoCard
            label={t("email")}
            value={userDetails?.email ?? "N/A"}
            isLoading={isLoading}
            icon={Mail}
            color="green"
          />
          <InfoCard
            label={t("phone")}
            value={userDetails?.phone ?? "N/A"}
            isLoading={isLoading}
            icon={Phone}
            color="red"
          />
          <InfoCard
            label={t("birthdate")}
            value={userDetails?.birthdate ?? "N/A"}
            isLoading={isLoading}
            icon={Cake}
            color="purple"
          />
        </div>

        <h4 className="text-lg font-bold">{t("addresses")}</h4>
        <div className="grid grid-cols-2 flex-wrap gap-8">
          {addresses.map((address) => (
            <InfoCard
              label={address.label}
              value={address.address}
              icon={
                address.label === "home"
                  ? Home
                  : address.label === "work"
                  ? BriefcaseBusiness
                  : MapPin
              }
              color="orange"
              editable
              deletable
              onEdit={() => {
                openAddressModal({
                  addressToEdit: address,
                });
              }}
              onDelete={() => {
                deleteAddress(address);
              }}
            />
          ))}
          <InfoCard
            actionable
            label={t("add_address")}
            value={t("add_address")}
            icon={Plus}
            color="orange"
            onAction={() => {
              openAddressModal({});
            }}
          />
        </div>
      </div>
    </div>
  );
}
